<template>
  <el-select class="mw-240 w-100p" filterable clearable :multiple="this.selectType == 20" :placeholder="placeholder" v-model="childValue" @input="change" :disabled="disabled">
    <el-option :label="option.name" :value="option.struct_id" v-for="option in options"></el-option>
  </el-select>
</template>
<script>
  import modelConfig from '../../../../config/modelConfig'
  import _verify from '../../../../assets/js/verify'
  export default {
    props: ['value', 'name', 'disabled', 'rules', 'options', 'placeholder', 'selectType', 'default', 'range'],
    data() {
      return {
        childValue: null
      }
    },
    created() {
      this.init()
    },
    methods: {
      init() {
        if (this.value) {
          if (typeof (this.value) == 'string') {
            this.childValue = parseInt(this.value)
            this.change(this.childValue)
          } else if (typeof (this.value) == 'object') {
            this.childValue = this.value
          }
        } else {
          if (this.value == null) {
            if (this.selectType == 10) {
              this.setDefault()
            } else {
              this.setMultiDefault()
            }
          }
        }
      },
      change(value) {
        this.$emit('input', value)
      },
      setMultiDefault() {
        let arr = []
        const ustruct_id = Lockr.get('userInfo').structure_id
        if (this.range == 10) {
          if (this.default == 20) {
            arr.push(ustruct_id)
          } else if (this.default == 30) {
            _(this.options).forEach((res) => {
              if (res.is_selected) {
                arr.push(res.struct_id)
              }
            })
          }
        } else if (this.range == 20) {
          if (this.default == 20) {
            arr.push(ustruct_id)
          }
        } else if (this.range == 30) {
          if (this.default == 20) {
            arr.push(ustruct_id)
          } else if (this.default == 30) {
            _(this.options).forEach((res) => {
              if (res.is_selected) {
                arr.push(res.struct_id)
              }
            })
          }
        }
        this.childValue = arr
        this.change(this.childValue)
      },
      setDefault() {
        const ustruct_id = Lockr.get('userInfo').structure_id
        if (this.range == 10) {            // 默认值不限
          if (this.default == 20) {
            this.childValue = ustruct_id
          } else if (this.default == 30) {
            _(this.options).forEach((res) => {
              if (res.is_selected) {
                this.childValue = res.struct_id
              }
            })
          }
        } else if (this.range == 20) {    // 默认用户所属部门
          if (this.default == 20) {
            _(this.options).forEach((res) => {
              if (res.struct_id == ustruct_id) {
                this.childValue = ustruct_id
              }
            })
          } else if (this.default == 30) {
          }
        } else if (this.range == 30) {
          if (this.default == 20) {
            _(this.options).forEach((res) => {
              if (res.struct_id == ustruct_id) {
                this.childValue = ustruct_id
              }
            })
          } else if (this.default == 30) {
            _(this.options).forEach((res) => {
              if (res.is_selected) {
                this.childValue = res.struct_id
              }
            })
          }
        }
        this.change(this.childValue)
      }
    },
    mixins: [modelConfig]
  }
</script>



// WEBPACK FOOTER //
// honrayStruct.vue?0b594936